import ShopmnIcon from '@/assets/logo-icon-black.svg'

// Fallback for products with no photo. The card's image box already carries the grey
// background, so this only paints the mark on top of it.
// ponytail: a low-opacity black <img> instead of recolouring the svg — black at 10% on
// grey reads as "slightly darker grey" on its own. `light` inverts it for dark skins.
export default function NoImage({ light = false }: { light?: boolean }) {
  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <img
        src={(ShopmnIcon as any).src || ShopmnIcon}
        alt=""
        aria-hidden
        className={`w-1/4 max-w-14 opacity-10 ${light ? 'invert' : ''}`}
      />
    </div>
  )
}
